<template>
  <RegistrationForm @submit="handleSubmit">
    <template slot="header">
      <FormHeader tag="h2">Забронировать место</FormHeader>
    </template>

    <label for="interest_id">Выберите пакет:</label>
    <VueSelect :options="interestOptions.packagesMap" v-model="zoomWebinarPackage" :clearable="false" :searchable="false" :disabled="submitting || submitted" id="interest_id" />
  </RegistrationForm>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    computed: {
      ...mapState([
        'possibleInterestIds',
        'interestType',
        'interestId',
        'interestOptions',
        'submitting',
        'submitted',
      ]),
    },

    data () {
      return {
        packageId: null,
      };
    },

    methods: {
      ...mapActions(['submit']),

      handleSubmit ({ email, name, phone, gdprConfirmed, newsletter, recaptchaResponse }) {
        const { interestId, interestType, zoomWebinarPackage } = this;

        this.submit({
          email,
          name,
          phone,
          gdprConfirmed,
          newsletter,
          recaptchaResponse,
          interestId,
          interestType,
          interestOptions: {
            packageId: zoomWebinarPackage.value,
          },
        });
      },
    },

    created () {
      this.zoomWebinarPackage = this.interestOptions.packagesMap[0];
    },
  };
</script>
